/**
 * Browser entry point.
 *
 * @see docs/plan/IMPLEMENTATION_PLAN.md task 5.1
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';
import {
  initI18n,
  applyDocumentLanguage,
  readStoredLanguage,
  resolveInitialLanguage,
} from './i18n/config';
import './styles/index.css';

const container = document.getElementById('root');

/* Explicit rather than a non-null assertion: if the root element is missing,
   an empty page with a clear console error beats a stack trace from inside
   React that names neither the cause nor the file. */
if (!container) {
  throw new Error('Root element #root not found — check index.html');
}

/* i18n is initialised before the first render: mounting first would flash
   translation keys, and `Suspense` around the whole tree to avoid that costs
   more than awaiting a resolved bundle. */
const language = resolveInitialLanguage(readStoredLanguage(), navigator.languages);
await initI18n(language);
applyDocumentLanguage(language);

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
